export default __webpack_public_path__ + "static/media/btn-color-fr_fr@2x.e5ce18b7.png";